import { handleReturn, MutationFunction, PaginatedResponse, QueryFunction } from './root'
import { network } from '@root/utils'

export interface ITag {
  id: number
  created_at: string
  updated_at: string
  name: string
  description: string
  color: string
}

interface TagsListProps {
  slug: string
}

export const fetchTags: QueryFunction<TagsListProps, PaginatedResponse<ITag>> = async (
  { slug },
  params
) => {
  const url = `/v1/business/${slug}/tags/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET',
    params
  })
  return data
}

interface GetTagProps {
  slug: string
  tagId: number
}

export const fetchTag: QueryFunction<GetTagProps, ITag> = async ({ slug, tagId }) => {
  const url = `/v1/business/${slug}/tags/${tagId}/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET'
  })
  return data
}

interface CreateTagProps {
  slug: string
}

export const createTag: MutationFunction<CreateTagProps, ITag> = async ({ slug }, requestData) => {
  const url = `/v1/business/${slug}/tags/`
  const { data, status } = await network.httpClient.request({
    url,
    method: 'POST',
    data: requestData,
    validateStatus: () => true
  })
  return handleReturn({ status, data })
}

interface UpdateTagProps {
  slug: string
  tagId: number
}

export const updateTag: MutationFunction<UpdateTagProps, ITag> = async (
  { slug, tagId },
  requestData
) => {
  const url = `/v1/business/${slug}/tags/${tagId}/`
  const { data, status } = await network.httpClient.request({
    url,
    method: 'PATCH',
    data: requestData,
    validateStatus: () => true
  })
  return handleReturn({ status, data })
}

export const deleteTag: MutationFunction<UpdateTagProps, ITag> = async ({ slug, tagId }) => {
  const url = `/v1/business/${slug}/tags/${tagId}/`
  const { data, status } = await network.httpClient.request({
    url,
    method: 'DELETE',
    validateStatus: () => true
  })
  return handleReturn({ status, data })
}
